import { faCommentAltLines } from '@fortawesome/pro-regular-svg-icons';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import ChatHeader from './ChatHeader';
import { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/UI';

interface NoPhoneNumbeProps {
    onBackButton: () => void;
    onShowClient?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%'
        },
        title: {
            fontSize: '42px',
            fontWeight: 600,
            lineHeight: '100%',
            margin: '16px 0',
            textAlign: 'center'
        },
        description: {
            textAlign: 'center',
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            marginBottom: '16px'
        },
        backButton: {
            cursor: 'pointer'
        },
        infoContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'center',
            padding: '0 96px'
        },
        iconContainer: {
            alignItems: 'center',
            backgroundColor: '#000',
            borderRadius: '91px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '91px',
            paddingTop: '6px',
            textAlign: 'center',
            width: '91px'
        },
        icon: {
            color: '#FFFFFF',
            height: 36,
            minWidth: 'unset',
            width: 36
        }
    })
);

const NoPhoneNumber: FunctionComponent<NoPhoneNumbeProps> = props => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div>
                <ChatHeader onBackButton={props.onBackButton} />
            </div>
            <div className={classes.infoContainer}>
                <div className={classes.iconContainer}>
                    <FontAwesomeIcon
                        icon={faCommentAltLines}
                        size="sm"
                        className={classes.icon}
                    />
                </div>
                <h1 className={classes.title}>Phone Number Needed</h1>
                <span className={classes.description}>
                    This client does not have a phone number added. Please add it to send SMS
                </span>
                {props.onShowClient && (
                    <Button
                        label="Add Phone Number"
                        onClick={props.onShowClient}
                    />
                )}
            </div>
        </div>
    );
};

export default NoPhoneNumber;
